import React from "react"
import BlogPreviewDescriptionStyle from "./BlogPreviewDescriptionStyle.module.styl"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import { BLOCKS } from "@contentful/rich-text-types"
import EmbeddedAssetModal from "../blogEmbeddedAssetModal/EmbeddedAssetModal"

const BlogPreviewDescription = ({
  description,
  toggleEmbeddedAssetModal,
  embeddedAssetModal,
  embeddedImage,
}) => {
  const options = {
    renderNode: {
      [BLOCKS.HEADING_1]: (node, children) => (
        <h1 className="heading1">{children}</h1>
      ),
      [BLOCKS.HEADING_2]: (node, children) => (
        <h2 className="heading2">{children}</h2>
      ),
      [BLOCKS.HEADING_3]: (node, children) => (
        <h3 className="heading3">{children}</h3>
      ),
      [BLOCKS.HEADING_4]: (node, children) => (
        <h4 className="heading4">{children}</h4>
      ),
      [BLOCKS.EMBEDDED_ASSET]: (node, children) => (
        <React.Fragment>
          <img
            /* eslint-disable-next-line */
            role="button"
            onKeyDown={() =>
              toggleEmbeddedAssetModal(
                `https:${node.data.target.fields.file["en-US"].url}`
              )
            }
            onClick={() =>
              toggleEmbeddedAssetModal(
                `https:${node.data.target.fields.file["en-US"].url}`
              )
            }
            className="blog-preview-image"
            alt="preview"
            src={`https:${node.data.target.fields.file["en-US"].url}`}
          />
        </React.Fragment>
      ),
      [BLOCKS.PARAGRAPH]: (node, children) => (
        <p className="text-format">{children}</p>
      ),
    },
    renderMark: {},
  }
  return (
    <React.Fragment>
      <div className={BlogPreviewDescriptionStyle.holder}>
        {documentToReactComponents(description, options)}
      </div>
      <EmbeddedAssetModal
        embeddedImage={embeddedImage}
        embeddedAssetModal={embeddedAssetModal}
        toggleEmbeddedAssetModal={toggleEmbeddedAssetModal}
      />
    </React.Fragment>
  )
}

export default BlogPreviewDescription
